import React, { Component } from 'react'
import {
  FormControl
} from 'react-bootstrap'

export default class Dropdown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedValue: 0
    }
  }

  handleOnChange(e) {
    this.setState({
      selectedValue: e.target.value
    })

    this.props.onChange(e)
  }

  render() {
    if (this.props.data == undefined) {
      return (
        <div>Error: no data provided!</div>
      )
    } else if (this.props.data.length < 1) {
      return (
        <FormControl componentClass="select" id={ this.props.id }>
          <option value="">Loading...</option>
        </FormControl>
      )
    } else {
      let selectedValue = this.props.defaultValue
      if (this.state.selectedValue > 0) {
        selectedValue = this.state.selectedValue
      }

      return (
        <FormControl componentClass="select" id={ this.props.id } value={ selectedValue } onChange={ this.handleOnChange.bind(this) }>
        {
          this.props.data.map((item) => {
            return <option value={ item.id }>{ item.name }</option>
          })
        }
        </FormControl>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdown.js